import {
  FirebaseApp,
  FirebaseOptions,
  getApp,
  getApps,
  initializeApp,
} from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";

const AUTH_WRAPPER_APP_NAME = "auth-wrapper";

let firebaseApp: FirebaseApp | null = null;
let firebaseAuthInstance: Auth | null = null;
let firestoreDBInstance: Firestore | null = null;

/**
 * Initializes the shared auth-wrapper Firebase app singleton.
 *
 * Reuses an existing named app when present to avoid duplicate-app errors
 * when host dashboards initialize Firebase before the wrapper mounts.
 *
 * @param config - Firebase configuration for the current environment
 * @returns Initialized Firebase app instance for auth-wrapper
 */
export function initializeFirebase(config: FirebaseOptions): FirebaseApp {
  if (!firebaseApp) {
    firebaseApp = getApps().some((app) => app.name === AUTH_WRAPPER_APP_NAME)
      ? getApp(AUTH_WRAPPER_APP_NAME)
      : initializeApp(config, AUTH_WRAPPER_APP_NAME);
    firebaseAuthInstance = getAuth(firebaseApp);
    firestoreDBInstance = getFirestore(firebaseApp);
  }
  return firebaseApp;
}

export function getFirebaseAuth(): Auth {
  if (!firebaseAuthInstance) {
    throw new Error(
      "Firebase not initialized. Call initializeFirebase() first.",
    );
  }
  return firebaseAuthInstance;
}

export function getFirestoreDB(): Firestore {
  if (!firestoreDBInstance) {
    throw new Error(
      "Firebase not initialized. Call initializeFirebase() first.",
    );
  }
  return firestoreDBInstance;
}

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseApp) {
    throw new Error(
      "Firebase not initialized. Call initializeFirebase() first.",
    );
  }
  return firebaseApp;
}
